import { Packer, Document, Paragraph, TextRun } from 'docx'
import JsPDF from 'jspdf'
import { StoreSelfIntroduction_SelfIntroductionFragment } from 'generated/graphql'
import {
  formatBlankType,
  formatCharMaxSize,
  getAnswerLength,
} from '@app.feature/coverletter/coverletter.write/libs/utils'

// TODO: PDF 파일 포맷
// TODO: 사파리 인쇄하기

/** 자소서 포맷 변환 */
export const formatSelfIntroductionToText = (
  data: StoreSelfIntroduction_SelfIntroductionFragment,
) => {
  if (!data.qna) return ``

  const qnaStrings = data.qna.map((qna) => {
    const answerLength = getAnswerLength(
      qna.answer || '',
      qna.blankType,
      qna.charSize,
    )
    const blankType = formatBlankType(qna.blankType)
    const charSize = formatCharMaxSize(qna.charSize)
    return `
${qna.seq}. ${qna.question} ${answerLength}/${qna.charMaxSize}(${charSize}, ${blankType})

${qna.answer}
`
  })

  const result = `
${data.title}

${qnaStrings.join(`\n\n`)}

링커리어
`

  return result
}

const downloadBlob = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.download = filename
  link.href = url
  link.click()
}

export const exportTxt = (
  data: StoreSelfIntroduction_SelfIntroductionFragment,
) => {
  const fileData = formatSelfIntroductionToText(data)
  const utf8Bom = '\uFEFF' // UTF-8 BOM
  const content = utf8Bom + fileData
  const blob = new Blob([content], { type: 'text/plain;charset=utf-8' })
  downloadBlob(blob, `${data.title}_링커리어.txt`)
}

const getSplittedLines = (text: string | string[], length: number) => {
  const lineLength = Math.ceil(text.length / length)
  const lines = new Array(lineLength).fill('')
  lines.forEach((_, index) => {
    lines[index] = text.slice(index * length, (index + 1) * length)
  })
  return lines
}

const formatSelfintroductionToJsPDF = async (
  data: StoreSelfIntroduction_SelfIntroductionFragment,
) => {
  const response = await fetch('/fonts/malgun.ttf')
  const fontBlob = await response.blob()
  const fontBase64 = (await blobToBase64(fontBlob)) as string

  const doc = new JsPDF({ format: 'a4' })
  doc.addFileToVFS('malgun.ttf', fontBase64)
  doc.addFont('malgun.ttf', 'malgun', 'normal')
  doc.setFont('malgun')

  /*
  doc.addImage(
    'https://raw.githubusercontent.com/MrRio/jsPDF/master/examples/images/Octonyan.jpg',
    'JPEG',
    15,
    40,
    170,
    170,
  )
  */

  if (!data.qna) return doc

  const lines: string[] = []
  doc.setFontSize(12)
  //* 자기소개서 제목
  lines.push(data.title || '')

  // lines.push('마감일 : 22-10-07 23:59')
  lines.push('')
  lines.push('')

  data.qna.forEach((qna, idx) => {
    // * 문항 제목
    const questionLines = doc.splitTextToSize(
      `${idx + 1}.${qna.question || '문항 제목 없음'}`,
      170,
    )
    lines.push(...questionLines)

    const answerLength = getAnswerLength(
      qna.answer || '',
      qna.blankType,
      qna.charSize,
    )
    const blankType = formatBlankType(qna.blankType)
    const charSize = formatCharMaxSize(qna.charSize)
    lines.push(`${answerLength}/${qna.charMaxSize}(${charSize}, ${blankType})`)
    lines.push('')

    // * 문항 답변
    const answerLines = doc.splitTextToSize(
      `${qna.answer || '문항 내용 없음'}`,
      170,
    )
    lines.push(...answerLines)
    lines.push('')
  })
  const pages: string[][] = getSplittedLines(lines, 50)

  pages.forEach((pageLines, idx) => {
    if (idx !== 0) {
      doc.addPage()
    }
    doc.text(pageLines, 20, 20)
  })

  return doc
}

const blobToBase64 = (blob: Blob) => {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result?.slice(21))
    reader.readAsDataURL(blob)
  })
}

export const exportPdf = async (
  data: StoreSelfIntroduction_SelfIntroductionFragment,
) => {
  const doc = await formatSelfintroductionToJsPDF(data)
  doc.save(`${data.title}_링커리어.pdf`)
}

export const printPdf = async (
  data: StoreSelfIntroduction_SelfIntroductionFragment,
) => {
  const doc = await formatSelfintroductionToJsPDF(data)
  doc.autoPrint()
  const docString = doc.output('datauristring')
  const iframe = window.document.createElement('iframe')

  iframe.setAttribute('src', docString)
  iframe.setAttribute('style', 'position: absolute; width: 1px; height: 1px;')
  window.document.body.appendChild(iframe)
  // iframe.focus()
  iframe.contentWindow?.print()
}

export const exportDocx = async (
  data: StoreSelfIntroduction_SelfIntroductionFragment,
) => {
  const textRunChildren: TextRun[] = formatSelfIntroductionToText(data)
    .split('\n')
    .map((line) => {
      return new TextRun({
        text: line,
        break: 1,
      })
    })

  const doc = new Document({
    sections: [
      {
        properties: {},
        children: [
          new Paragraph({
            children: textRunChildren,
          }),
        ],
      },
    ],
  })

  const blob = await Packer.toBlob(doc)
  downloadBlob(blob, `${data.title}_링커리어.docx`)
}
